export default __webpack_public_path__ + "static/media/logo-white.51adceca6a95f7dc9efd274d75bce66d.png";